import { CalendarHeaderContext, CalendarHeaderContextType } from '../../../../context/calendar-header-context';
import { CalendarViewV3HeaderContext } from '../../../../context/CalendarViewV3HeaderContext';
import { CalendarViewV3HeaderContextType } from '../../../../types';
import { Container } from './container';

export const CalendarHeader = (props: CalendarHeaderContextType & CalendarViewV3HeaderContextType) => (
  <CalendarHeaderContext.Provider value={props}>
    {/* TODO: Remove `CalendarViewV3HeaderContext` once the `scheduleSmallMode` flag is removed (when new calendar header is permanantly used). 
        This also requires change in the child components to use `CalendarHeaderContext` instead of `CalendarViewV3HeaderContext`
    */}
    <CalendarViewV3HeaderContext.Provider value={props}>
      <Container />
    </CalendarViewV3HeaderContext.Provider>
  </CalendarHeaderContext.Provider>
);
